import axios from 'axios';
import { find as _find, get as _get } from 'lodash';

import { ROUTE_ID } from '../../routing/routeConfig';
import { CoreFeatures } from './constants/productFeatures';

export default {
  async isWorkflowsEnabled() {
    try {
      const resp = await axios.get(`${window.env.REACT_APP_SINE_WORKFLOWS_API_URI}/user/is-workflows-enabled`);
      return resp.data;
    } catch (err) {
      return false;
    }
  },

  async isAdminPluginsEnabled() {
    try {
      const { data } = await axios.get(`${window.env.REACT_APP_SINE_CORE_API_URI}/user/my/is-admin-plugins-enabled`);
      return data;
    } catch (err) {
      return false;
    }
  },

  async isLobbyModeEnabled() {
    try {
      const { data: lobbyModeEnabled } = await axios.get(
        `${window.env.REACT_APP_SINE_CORE_API_URI}/user/my/is-lobby-mode-enabled`,
      );
      return lobbyModeEnabled;
    } catch (err) {
      return false;
    }
  },

  async isIdentifierEnabled(teamId) {
    // TODO: VMS-249: CREATE AN ENDPOINT TO CHECK IF IDENTIFIER IS ENABLED
    try {
      const data = await this.getTeamFeatures(teamId);
      const checklistsFeature = _find(data, { name: CoreFeatures.CHECKLISTS_IDENTIFIER });

      return _get(checklistsFeature, 'teamFeatureEnabled') === true;
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async isAdvancedChecklistsEnabled() {
    const { data } = await axios.get(
      `${window.env.REACT_APP_SINE_CORE_API_URI}/user/my/is-advanced-checklists-enabled`,
    );
    return data;
  },

  async getTeamFeatures(teamId) {
    const resp = await axios.get(`${window.env.REACT_APP_SINE_CORE_API_URI}/feature/${teamId}`);
    return resp.data;
  },

  async getEnabledTeamFeatures(teamId) {
    const resp = await axios.get(`${window.env.REACT_APP_SINE_CORE_API_URI}/feature/${teamId}/enabled/v2`);
    return resp.data;
  },

  async setTeamFeature(teamId, data) {
    const resp = await axios.post(`${window.env.REACT_APP_SINE_CORE_API_URI}/feature/${teamId}`, data);
    return resp.data;
  },

  async isFeatureEnabled(feature) {
    switch (feature) {
      case ROUTE_ID.ZONES: {
        const { data } = await axios.get(`${window.env.REACT_APP_SINE_CORE_API_URI}/user/my/is-zones-enabled`);
        return data;
      }
      default: {
        return false;
      }
    }
  },
};
